import * as React from 'react';
import IconEdit from 'material-ui/svg-icons/editor/mode-edit';
import IconButton from 'material-ui/IconButton';
import { staticUrl } from '../../lib/config';

import { colors } from '../../lib/styles';
import './player-btn.css';

const GcorePlayer = window.GcorePlayer;

const getConfig = (config, element) => ({
	...config,
	sources: (config.sources || []).map(item => ({
		...item,
		source: item.src,
	})),
	width: '100%',
	height: 453,
	playerElement: element,
	poster: config.poster ? `${staticUrl}/${config.poster}` : `${config.sources[0].src.replace('.mp4', '')}/preview.jpg`,
});

export default class Player extends React.Component {
	static defaultProps = {
		style: { width: '100%', height: 453, maxWidth: 805 },
	};

	player: any;
	playerElem;

	componentDidMount() {
		const { config } = this.props;
		this.player = new GcorePlayer.gcore(getConfig(config, this.playerElem));
		this.player.init();
	}

	componentWillUnmount() {
		this.player.destroy();
	}

	render() {
		const { config, edit } = this.props;
		return (
			<div
				className="player-wrapper"
				style={{
					...this.props.style,
					position: 'relative',
				}}
			>
				<div ref={player => (this.playerElem = player)} className="player" />
				{config.edit && (
					<IconButton
						className="player--btn"
						style={{
							position: 'absolute',
							backgroundColor: 'transparent',
							top: 0,
							right: 0,
						}}
						onClick={() => {
							edit(config);
						}}
					>
						<IconEdit color={colors.button} hoverColor={colors.linkHover} />
					</IconButton>
				)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// src/components/player/Player.js